import { InfoMessageBlock } from 'components';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

const withCollectionItem =
  (
    useHook,
    ItemContext,
    paramName = 'id',
    notFoundMessage = 'Item not found'
  ) =>
  (Component) => {
    const ItemComponent = (props) => {
      const collection = useHook();
      const params = useParams();
      const id = params[paramName];

      const itemDoc = useMemo(
        () => collection.data.find((item) => id === item.id),
        [collection, id]
      );

      if (!itemDoc) {
        return (
          <InfoMessageBlock title="Not found" description={notFoundMessage} />
        );
      }

      return (
        <ItemContext.Provider value={itemDoc}>
          <Component {...props} />
        </ItemContext.Provider>
      );
    };

    return observer(ItemComponent);
  };

export default withCollectionItem;
